import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

export function MapPanelCollapsableContent({
    collapsed,
    children,
    sx,
}: {
    collapsed: boolean;
    children: ReactNode;
    sx?: SxProps<Theme>;
}) {
    return (
        <Box
            sx={[
                theme => ({
                    display: "grid",
                    gridTemplateRows: collapsed ? "0fr" : "1fr",
                    transition: theme.transitions.create("grid-template-rows", {
                        duration: theme.transitions.duration.standard,
                        easing: "ease-in-out",
                    }),
                    overflow: "auto",
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            <Box
                sx={theme => ({
                    overflow: "auto",
                    opacity: collapsed ? 0 : 1,
                    transition: theme.transitions.create("opacity", {
                        duration: theme.transitions.duration.standard,
                        easing: "ease-in-out",
                    }),
                })}
            >
                {children}
            </Box>
        </Box>
    );
}
